import { AUTH_COOKIE_MAX_AGE_SECONDS, AUTH_COOKIES } from '../constants/authCookies';
import type { AuthCookieOptions } from '../types/session';
import type { AuthTokens } from '../types/transport';

/**
 * `Set-Cookie` / `document.cookie` strings that save the session tokens, or expire them with `null`.
 * Expiring needs the same `Domain` and `Path` the cookies were set with.
 */
export function serializeAuthCookies(
    tokens: AuthTokens | null,
    { domain, isSecure }: AuthCookieOptions = {},
): string[] {
    const attributes = [
        'Path=/',
        `Max-Age=${tokens ? AUTH_COOKIE_MAX_AGE_SECONDS : 0}`,
        'SameSite=Lax',
        ...(domain ? [`Domain=${domain}`] : []),
        ...(isSecure ? ['Secure'] : []),
    ].join('; ');

    return [
        `${AUTH_COOKIES.ACCESS}=${tokens ? encodeURIComponent(tokens.access_token) : ''}; ${attributes}`,
        `${AUTH_COOKIES.REFRESH}=${tokens ? encodeURIComponent(tokens.refresh_token) : ''}; ${attributes}`,
    ];
}
